import React from 'react'
import { Body, ContentfulRichText } from '@superhi/design'

import Hyperlink from '../ArticleBody/components/Hyperlink'

const NODE_OVERRIDES: React.ComponentProps<typeof ContentfulRichText>['nodeOverrides'] = {
  paragraph: (_, children) => <Body level="3">{children}</Body>,
  hyperlink: (node, children) => <Hyperlink url={node.data.uri}>{children}</Hyperlink>,
}

type Props = {
  children: string
}

const AuthorBio: React.FC<Props> = ({ children }) => (
  <div>
    <ContentfulRichText nodeOverrides={NODE_OVERRIDES}>{children}</ContentfulRichText>
  </div>
)

export default AuthorBio
